const sheetBlueprint = [
  {
    name: "Category_Type",
    type: "Reference",
    description:
      "Readonly list of reporting categories already configured for the company.",
    keyColumns: ["RC_Name", "RC_Description"],
    tips: [
      "Use these names to populate Category_Type_Name in the Categories sheet.",
      "If the list is empty, create reporting categories first in the BackOffice UI.",
    ],
  },
  {
    name: "Category_Departments",
    type: "Reference",
    description:
      "Readonly view of existing category departments that can be linked to categories.",
    keyColumns: ["CD_Name", "CD_SortOrder"],
    tips: [
      "Comma‑separate multiple department names when assigning to a category.",
      "Departments must exist before you upload the template.",
    ],
  },
  {
    name: "Categories",
    type: "Editable",
    description:
      "Add or update categories with their hierarchy, publishing flags, and department mapping.",
    keyColumns: [
      "Category_Name",
      "Parent_Category",
      "Category_Type_Name",
      "Category_Departments",
      "Is_Published",
    ],
    tips: [
      "Parent_Category should match the Category_Name of another row (or remain blank).",
      "Use Category_Type_Name from the Category_Type reference sheet.",
      "Use Category_Departments to link with names from the Category_Departments reference sheet.",
      "Set Is_Published to TRUE/FALSE explicitly.",
    ],
  },
  {
    name: "Modifier_Groups",
    type: "Editable",
    description:
      "Define modifier groups (e.g., Size Options) with their selection rules.",
    keyColumns: [
      "Group_Name",
      "Group_SubTitle",
      "Can_Skip",
      "Min_Selection",
      "Max_Selection",
      "Free_Selection",
      "Extra_Charge",
    ],
    tips: [
      "Group_Name must be unique; products will reference this name.",
      "Group_Type is automatically set to 'List' by the system.",
      "Set Can_Skip to FALSE for required modifier selections.",
      "Min/Max selection enforce UI behavior on the till.",
    ],
  },
  {
    name: "Modifiers",
    type: "Editable",
    description:
      "List every modifier item and attach it to a modifier group defined in the previous sheet.",
    keyColumns: [
      "Group_Name",
      "Modifier_Name",
      "Modifier_SKU",
      "Sale_Price",
      "Cost_Price",
      "Tax_Percentage",
      "Delivery_Price",
      "Takeaway_Price",
      "Reporting_Category_Name",
      "Is_Default",
      "Sort_Order",
    ],
    tips: [
      "Group_Name must exist in the Modifier_Groups sheet.",
      "Reporting_Category_Name must match a name from the Category_Type sheet. If left blank, it will default to 0.",
      "Use Is_Default to pre-select the modifier when exactly one is required.",
      "Sort_Order controls the display order inside the till.",
    ],
  },
  {
    name: "Products",
    type: "Editable",
    description:
      "Create/update menu items and link them to categories, modifier groups, and reporting categories.",
    keyColumns: [
      "Product_Name",
      "Category_Names",
      "Reporting_Category_Name",
      "Sale_Price",
      "Tax_Percentage",
      "Modifier_Group_Names",
      "Measurement_Type",
      "Default_Size_Unit",
      "Is_Buying_Product",
      "Is_Selling_Product",
      "Is_Stocking_Product",
    ],
    tips: [
      "Category_Names accepts comma-separated values; each must exist in the Categories sheet.",
      "Modifier_Group_Names accepts comma-separated names from Modifier_Groups.",
      "Product_Type is automatically set to 'Product' by the system.",
      "Reporting_Category_Name should match a name from the Category_Type sheet. If not provided, the first category's reporting category will be used.",
      "Measurement_Type must be one of Unit, Weight, or Volume.",
      "Default_Size_Unit must belong to the selected Measurement_Type (see Measurement_Units_Reference sheet).",
      "Use TRUE/FALSE for Is_Buying_Product, Is_Selling_Product, and Is_Stocking_Product.",
    ],
  },
  {
    name: "Product_Variants",
    type: "Editable",
    description:
      "Optional sheet for defining variants (e.g., Small / Medium / Large) tied to parent products.",
    keyColumns: [
      "Parent_Product_Name",
      "Variant_Name",
      "Sale_Price",
      "Is_Default_Variant",
      "Measurement_Type",
      "Default_Size_Unit",
      "Is_Buying_Product",
      "Is_Selling_Product",
      "Is_Stocking_Product",
    ],
    tips: [
      "Parent_Product_Name must match a Product_Name from the Products sheet.",
      "Exactly one variant per parent should have Is_Default_Variant = TRUE.",
      "Use Measurement_Type as Unit, Weight, or Volume and ensure Default_Size_Unit matches that type.",
    ],
  },
];

export default sheetBlueprint;

